import React from 'react';
import t from 'prop-types';
import SegundaVentanaContainer from './containers/segunda-ventana-container';
import PrimeraVentanaContainer from './containers/primera-ventana-container';
import BarraHerramientasContainer from '../barra-herramientas/barra-herramientas-container';
import BotonHerramientasContainer from '../boton-herramientas/boton-herramientas-container';
import { CronoContainer } from '../crono';
import MascarasContainer from '../mascaras';

var Ventana = function Ventana(_ref) {
  var libroId = _ref.libroId,
      numPagina = _ref.numPagina,
      numZona = _ref.numZona,
      zona = _ref.zona,
      boton = _ref.boton,
      textoTrack = _ref.textoTrack,
      _onBoton = _ref.onBoton,
      onCerrar = _ref.onCerrar,
      onCerrarSegundaVentana = _ref.onCerrarSegundaVentana;
  return React.createElement('div', {
    className: 'contenedor libro' + libroId
  }, React.createElement(PrimeraVentanaContainer, {
    abierta: true,
    libroId: libroId,
    numPagina: numPagina,
    numZona: numZona,
    zona: zona,
    textoTrack: textoTrack,
    onBoton: function onBoton(boton) {
      return _onBoton(libroId, numPagina, numZona, boton);
    },
    onCerrar: onCerrar
  }), boton && React.createElement(SegundaVentanaContainer, {
    abierta: true,
    libroId: libroId,
    numPagina: numPagina,
    numZona: numZona,
    boton: boton,
    textoTrack: textoTrack,
    onBoton: function onBoton(boton) {
      return _onBoton(libroId, numPagina, numZona, boton);
    },
    onCerrar: onCerrarSegundaVentana
  }), React.createElement(MascarasContainer, null), React.createElement(BarraHerramientasContainer, null), React.createElement(BotonHerramientasContainer, null), React.createElement(CronoContainer, null));
};

Ventana.propTypes = process.env.NODE_ENV !== "production" ? {
  libroId: t.string,
  numPagina: t.number,
  numZona: t.string,
  zona: t.object,
  boton: t.object,
  textoTrack: t.string,
  onBoton: t.func,
  onCerrar: t.func,
  onCerrarSegundaVentana: t.func
} : {};
export default Ventana;